// Clone of Baccarat Roadmap
import React from 'react';
import {
	addBigRoadDisplay,
	addDisplayTile,
	addRoadmapType,
	addTieDisplay,
	checkLastIdx,
	// getSimpleFanTanResultArray,
	prepareV3Render,
	renderV3,
	resetAnalysisPointer,
	resetDisplayPointer,
	resetTieCount
} from "@/modules/games/BaccaratRoadmaps";

import nary from "@/modules/nary";
import { IV2RoadmapClass } from "@/types/V2RoadmapTypes";

//How to adjust length:
//- Change totalColumns in constructor

//Todo: fill Bead Road with Odd/Even
//Todo: fill Big Road with Fan 1-4

//Todo: process Big Eye Road, Small Road, Cockroach Road, and Predictions with hidden Big Road
//Todo: fill hidden Big Road with Odd/Even, the processing is the same as Baccarat
//Todo: clone getSimpleDragonTigerResultArray, then fix it to be compatible with FanTan Odd/Even

//Todo: make the scrolling happen

export default class M25 extends IV2RoadmapClass {
	oddPrediction: JSX.Element[];
	evenPrediction: JSX.Element[];

	render() {
		prepareV3Render(this);

		//Obligatory counters
		this.currentRow = 0;
		this.currentCol = -1;
		this.currentType = "";
			
		//Note: always use actual history array on release
		//Actual history array
		const history = this.props.history;

		//Skips render when history props is empty
		if (!history) return null;

		// Formats history to desired roadmap
		switch (this.props.type) {
			case "bead-road":
				this.currentRow = -1;
				this.currentCol = 0;
			
				if (Math.ceil(history.length / 6) >= this.totalColumns)
					this.firstDisplayedCol = Math.ceil(history.length / 6) - this.totalColumns;
			
				// console.log("m23 hist", history);

				history.map(item => item.angka)
				// "1332432134331222141221114211123344122141114111314442121412122111111124131214".split("").forEach((item, idx) => {
				.forEach((item, idx) => {
					let ele = null;
					
					const odd = parseInt(item, 10) % 2;

					if (this.currentRow >= 5) {
						this.currentRow = 0;
						this.currentCol += 1;
					} else
						this.currentRow += 1;
					
					if (odd) {
						ele = (<div className={"sl-roadmap-circle sl-roadmap-red " + (checkLastIdx(this.props.history, idx) ? this.alternatingStyle : null)}>
							<div className={"sl-baccarat-bead-value " + (checkLastIdx(this.props.history, idx) ? this.alternatingStyle : null)}>
								O
							</div>
						</div>);
					} else if (!odd) {
						ele = (<div className={"sl-roadmap-circle sl-roadmap-blue " + (checkLastIdx(this.props.history, idx) ? this.alternatingStyle : null)}>
							<div className={"sl-baccarat-bead-value " + (checkLastIdx(this.props.history, idx) ? this.alternatingStyle : null)}>
								E
							</div>
						</div>);
					}
					
					this.roadmapDisplay[this.currentRow][this.currentCol] = ele;
				});
			break;
			
			case "fan":
				this.currentRow = -1;
				this.currentCol = 0;
			
				const fantanClasses = {"1": "white", "2": "green", "3": "yellow", "4": "red"};
				
				this.firstDisplayedCol = (history.length >= this.totalColumns) ?
					history.length - this.totalColumns + 1 :
					this.firstDisplayedCol = 1;
			
				// console.log("fan fantan m25 hist", history);
			
				// const simpleHistoryAry = "1332432134331222141221114211123344122141114111314442121412122111111124131214".split("");
				const simpleHistoryAry = history.map(item => item.angka);
				
				//Each game
				simpleHistoryAry.forEach((item, idx) => {
					let ele = null;
					
					this.currentRow = parseInt(item, 10) - 1;
					this.currentCol += 1;
					
					ele = (
						<div className={"sl-roadmap-circle fantan sl-fantan-" + fantanClasses[item] + " " + (checkLastIdx(this.props.history, idx) ? this.alternatingStyle : null)}>
							<div className={"sl-baccarat-bead-value " + (checkLastIdx(this.props.history, idx) ? this.alternatingStyle : null)}>
								{ item }
							</div>
						</div>
					);

					if (!this.roadmapDisplay[this.currentRow])
						this.roadmapDisplay[this.currentRow] = [];
					
					this.roadmapDisplay[this.currentRow][this.currentCol] = ele;
				});
			break;
			
			case "big-road":
			case "big-eye-road":
			case "small-road":
			case "cockroach-road":
			case "predictions":
				resetDisplayPointer(this);
				resetAnalysisPointer(this);
				
				// console.log("sBR", this.simpleBigRoad);
				
				//Hollow circles
				//Test case 1
				// ["OEEEOEEEOEOEOEOEEEEOEEOEEOEEEOEEEOEEOEEEEOEEOEEEOEEOEE"].join("").split("")

				 //Actual data
				this.simpleBigRoad.forEach((item, idx) => {
					if (item === "T")
						addTieDisplay(this, this.roadmapTiesDisplay);
					else {
						addBigRoadDisplay(this, this.roadmapDisplay,
							item === "O" ? <div key={"sBR" + idx} className={"sl-roadmap-circle-hollow sl-roadmap-red " + (checkLastIdx(this.simpleBigRoad, idx) ? this.alternatingStyle : 0)} /> :
							item === "E" ? <div key={"sBR" + idx} className={"sl-roadmap-circle-hollow sl-roadmap-blue " + (checkLastIdx(this.simpleBigRoad, idx) ? this.alternatingStyle : 0)} /> :
							null
						, item);
						
						// Use straight columns to set this.roadmapTypes columns, not dragon tail
						
						addRoadmapType(this, this.roadmapTypes, item);
						
						resetTieCount(this);
					}
				});

				// console.log("this.roadmapTypes", this.roadmapTypes);
				
				// console.log("sBR", this.simpleBigRoad, "sBRP", this.simpleBigRoadPairs, "bRS", this.bigRoadSequence);
				// console.log("rPD", roadmapPairsDisplay);
				
				resetDisplayPointer(this);
			break;
			
			default: break;
		}

		//Resets counter for 2nd filter
		// this.currentRow = 0;
		// this.currentCol = 0;
		
		let startingCol;
		
		let redElement, blueElement, redBlinkElement, blueBlinkElement;
		
		switch (this.props.type) {
			case "big-eye-road":
				redElement = <div className="sl-roadmap-circle-hollow sl-roadmap-red" />;
				blueElement = <div className="sl-roadmap-circle-hollow sl-roadmap-blue" />;

				redBlinkElement = <div className={"sl-roadmap-circle-hollow sl-roadmap-red " + this.alternatingStyle} />;
				blueBlinkElement = <div className={"sl-roadmap-circle-hollow sl-roadmap-blue " + this.alternatingStyle} />;
				startingCol = 1;
				break;
			case "small-road":
				redElement = <div className="sl-roadmap-circle sl-roadmap-red" />;
				blueElement = <div className="sl-roadmap-circle sl-roadmap-blue" />;

				redBlinkElement = <div className={"sl-roadmap-circle sl-roadmap-red " + this.alternatingStyle} />;
				blueBlinkElement = <div className={"sl-roadmap-circle sl-roadmap-blue " + this.alternatingStyle} />;
				startingCol = 2;
				break;
			case "cockroach-road":
				redElement = <div className="sl-roadmap-slash sl-roadmap-red" />;
				blueElement = <div className="sl-roadmap-slash sl-roadmap-blue" />;

				redBlinkElement = <div className={"sl-roadmap-slash sl-roadmap-red " + this.alternatingStyle} />;
				blueBlinkElement = <div className={"sl-roadmap-slash sl-roadmap-blue " + this.alternatingStyle} />;
				startingCol = 3;
				break;
			default: break;
		}
		
		let a = 0;
		
		switch (this.props.type) {
			case "big-eye-road":
			case "small-road":
			case "cockroach-road":
				this.currentRow = 1;
				this.currentCol = startingCol; //1 //for big-eye-road
				
				for (a = 0; a < 9; a++)
					this.roadmapDisplay[a] = nary(9).map(item => null);
				
				//Evaluate the same column, first column
				if (this.roadmapTypes[1][this.currentCol]) {
					for (a = 1; a < this.roadmapTypes.length; a++) {
						if (!this.roadmapTypes[a][this.currentCol])
							break;
						
						//Evaluate the same column
						//startingCol = 1 for big-eye-road
						if (this.roadmapTypes[a][this.currentCol - startingCol] ===
							this.roadmapTypes[a - 1][this.currentCol - startingCol])
							addDisplayTile(this, this.roadmapDisplay, redElement, "red");
						else addDisplayTile(this, this.roadmapDisplay, blueElement, "blue");
					}
				}
				
				this.currentRow = 0;
				this.currentCol++;
				
				for (; this.currentCol < this.roadmapTypes[0].length;) {
					//Evaluate the next column
					if (this.roadmapTypes[0][this.currentCol]) {
						//Count filled cells
						let lengthLeft = 0, lengthRight = 0;
	
						//startingCol = 1 for big-eye-road
						for (a = 0; a < this.roadmapTypes.length; a++) {
							if (this.roadmapTypes[a][this.currentCol - startingCol - 1])
								lengthLeft++;
							if (this.roadmapTypes[a][this.currentCol - 1])
								lengthRight++;
						}
						
						// console.log("left:" + lengthLeft, "right:" + lengthRight);
						//Compare column lengths
						if (lengthLeft === lengthRight)
							addDisplayTile(this, this.roadmapDisplay, redElement, "red");
						else addDisplayTile(this, this.roadmapDisplay, blueElement, "blue");
					}
					
					this.currentRow++;
					
					//Checks empty cell of the next row
					if (this.roadmapTypes[this.currentRow][this.currentCol])
						for (; this.currentRow < this.roadmapTypes.length; this.currentRow++) {
							//Evaluate the same column
							
							//Checks empty cell
							if (this.roadmapTypes[this.currentRow][this.currentCol]) {
								//Checks adjacent cells
								if (this.roadmapTypes[this.currentRow][this.currentCol - startingCol] === //1
									this.roadmapTypes[this.currentRow - 1][this.currentCol - startingCol])
									addDisplayTile(this, this.roadmapDisplay, redElement, "red");
								else addDisplayTile(this, this.roadmapDisplay, blueElement, "blue");
							} else break;
						}
	
					this.currentRow = 0;
					this.currentCol++;
				}
				
				if (this.props.historyBlink && this.simpleBigRoad[this.simpleBigRoad.length - 1] !== "T")
					if (this.currentType === "red")
						this.roadmapDisplay[this.currentDisplayRow][this.currentDisplayCol] = redBlinkElement;
					else this.roadmapDisplay[this.currentDisplayRow][this.currentDisplayCol] = blueBlinkElement;
			break;
			
			
			case "predictions":
				this.oddPrediction = [];
				this.evenPrediction = [];
				const redElements = [
					<div key="roadmap_circle_hollow_red" className="sl-roadmap-circle-hollow sl-roadmap-red" />,
					<div key="roadmap_circle_red" className="sl-roadmap-circle sl-roadmap-red" />,
					<div key="roadmap_slash_red" className="sl-roadmap-slash sl-roadmap-red" />
				];
				const blueElements = [
					<div key="roadmap_circle_hollow_blue" className="sl-roadmap-circle-hollow sl-roadmap-blue" />,
					<div key="roadmap_circle_blue" className="sl-roadmap-circle sl-roadmap-blue" />,
					<div key="roadmap_slash_blue" className="sl-roadmap-slash sl-roadmap-blue" />
				];

					
				startingCol = 0;
				let startingRow = 0;
				
				// console.log("rT", this.roadmapTypes);

				if (!this.bigRoadSequence[this.bigRoadSequence.length - 1])
					break;

				startingRow = this.bigRoadSequence[this.bigRoadSequence.length - 1][0];
				startingCol = this.bigRoadSequence[this.bigRoadSequence.length - 1][1];
				
				this.currentType = this.roadmapTypes[startingRow][startingCol];
				
				const currentPlayer = 
					this.currentType === "O" ? "odd" :
					this.currentType === "E" ? "even" : "tie";
					
					
				// console.log("bRS", this.bigRoadSequence);
				
				//Use this.currentRow only for predictions on the same column (the same currentPlayer)
				for (a = 0; a < this.roadmapTypes.length; a++)
					if (this.roadmapTypes[a][this.currentCol])
						startingRow = a;
					else break;
				
				this.currentRow = startingRow;
				this.currentCol = startingCol;
				// console.log({this.currentCol: this.currentCol, this.currentRow: this.currentRow, this.currentType: this.currentType, currentPlayer: currentPlayer});
				

				//Banker and player are disabled for now
				
				//Evaluate banker
				if (currentPlayer === "odd") {
					this.currentRow += 1;
					
					for (a = 0; a < 3; a++) {
						if (this.currentCol - a - 1 < 0)
							this.evenPrediction[a] = redElements[a];
						else if (this.roadmapTypes[this.currentRow][this.currentCol - a - 1] ===
							this.roadmapTypes[this.currentRow - 1][this.currentCol - a - 1])
							this.evenPrediction[a] = redElements[a];
						else this.evenPrediction[a] = blueElements[a];
					}
				} else {
					//evaluate different column
				
					this.currentRow = 0;
					this.currentCol += 1;
					// console.log("pred banker", this.currentRow, this.currentCol);
					
					let lengthLeft, lengthRight;
					
					for (let col = 0; col < 3; col++) {
						if (this.currentCol - col - 2 < 0) {
							this.evenPrediction[col] = redElements[col];
							continue;
						}
						
						lengthLeft = 0;
						lengthRight = 0;
						for (a = 0; a < this.roadmapTypes.length; a++) {
							if (this.roadmapTypes[a][this.currentCol - col - 2])
								lengthLeft++;
							if (this.roadmapTypes[a][this.currentCol - 1])
								lengthRight++;
						}
						
						this.evenPrediction[col] = (lengthLeft === lengthRight) ?
							redElements[col] : blueElements[col];
					}
				}
				
				this.currentRow = startingRow;
				this.currentCol = startingCol;
				
				//Evaluate player
				if (currentPlayer === "even") {
					this.currentRow += 1;
					
					for (a = 0; a < 3; a++) {
						if (this.currentCol - a - 1 < 0)
							this.oddPrediction[a] = blueElements[a];
						else if (this.roadmapTypes[this.currentRow][this.currentCol - a - 1] ===
							this.roadmapTypes[this.currentRow - 1][this.currentCol - a - 1])
							this.oddPrediction[a] = redElements[a];
						else this.oddPrediction[a] = blueElements[a];
					}
				} else {
					//evaluate different column
					this.currentRow = 0;
					this.currentCol += 1;
					// console.log("pred player", this.currentRow, this.currentCol);
					
					for (let col = 0; col < 3; col++) {
						if (this.currentCol - col - 2 < 0) {
							this.oddPrediction[col] = blueElements[col];
							continue;
						}
						
						let lengthLeft = 0;
						let lengthRight = 0;
						for (a = 0; a < this.roadmapTypes.length; a++) {
							if (this.roadmapTypes[a][this.currentCol - col - 2])
								lengthLeft++;
							if (this.roadmapTypes[a][this.currentCol - 1])
								lengthRight++;
						}
						
						// console.log("ll, lr", lengthLeft, lengthRight);
						
						this.oddPrediction[col] = (lengthLeft === lengthRight) ?
							redElements[col] : blueElements[col];
					}
				}
				
				
			break;
			default: break;
		}
		
		return renderV3(this);
	}
}
